export default __webpack_public_path__ + "static/media/team-added.c10d0b61.png";